import Surveys from '../surveys/Surveys.vue';
import Notifications from '../notifications/Notifications.vue';
import Carousel from '../../../sharedComponents/carousel/Carousel.vue';
import statusColors from '../../../utils/status-colors';

export default {
  data() {
    return {
      pagePers: null,
      pageRules: null,
      dialogPers: false,
      dialogRules: false,
    };
  },
  components: {
    Surveys,
    Notifications,
    Carousel,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    dealersWithoutAddress() {
      return (this.user && (this.user.dealers && this.user.dealers.length)
        && this.user.dealers.filter(d => !d.fact_address)) || [];
    },
    dealersWithAddress() {
      return this.user.dealers || [];
    },
    purses() {
      return this.$store.state.purses;
    },
    requirePers() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_pers === true
          && state.user
          && !state.user.pers_at
      );
    },
    requireRules() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_rules === true
          && state.user
          && this.$store.state.agreedRules === false
      );
    },
    account() {
      return this.$store.state.user.account;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userIsChecked() {
      return true;
    },
    isBlocked() {
      return !!(this.$store.state.user
        && this.$store.state.user.blocked_at !== null);
    },
    hasSurvey() {
      return this.$store.state.surveys.hasSurvey;
    },
    isDisabledAccount() {
      return this.account && (this.account.status === 'approved' || this.account.status === 'new');
    },
    hasNotifications() {
      return this.$store.state.notifications.hasNotifications;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    settings() {
      return this.$store.state.settings;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    taxes() {
      return this.$store.state.settings.taxes === true;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    salesCount() {
      return this.$store.state.sales.meta?.totalCount || 0;
    },
  },
  methods: {
    GetColor(status) {
      return statusColors(status);
    },
    IsRemoteUrl(url) {
      return (url.indexOf('://') !== -1);
    },
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          this.$store.dispatch('GetProfile');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
        });
    },
    ConfirmRules() {
      this.$store.dispatch('AgreeingRules');
    },
  },
  created() {
    !this.user && this.$store.dispatch('GetProfile');
    !this.settings && this.$store.dispatch('GetSettings');
    this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
  },
  mounted() {
  },
  watch: {
    user() {
      if (this.user) {
        this.$store.dispatch('surveys/GetSurveys', this.user.profile_id);
        this.$store.dispatch('notifications/GetNotifications', this.user.profile_id);
        // this.$store.dispatch('sales/GetActionsList', { profile_id: this.user.profile_id });
        this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id });
        this.$store.dispatch('CheckAgreedRules').then(() => {
          if (this.requirePers || this.requireRules) {
            this.LoadPers();
          }
        });
      }
    },
  },
};
